import { object } from 'common/helpers'


export const initialState = {
  isFetching: false,
  selectedItems: [],
  selectedLandingItems: [],
}

export const selectItem = (state, payload /* payload = item.id */) => (
  object.update(state, 'selectedItems', (selectedItems) => {
    const newSelectedItems = selectedItems.slice()
    newSelectedItems.push(payload)
    return newSelectedItems
  })
)

export const deselectItem = (state, payload /* payload = item.id */) => (
  object.update(state, 'selectedItems', (selectedItems) => selectedItems.filter((id) => id !== payload))
)

export const setSelectedItems = (state, payload) => (
  object.set(state, 'selectedItems', payload)
)

export const setSelectedLandingItems = (state, payload) => (
  object.set(state, 'selectedLandingItems', payload)
)

export const clearSelectedItems = (state) => (
  object.set(state, 'selectedItems', [])
)

export const clearSelectedLandingItems = (state) => (
  object.set(state, 'selectedLandingItems', [])
)
